module.exports = __webpack_public_path__ + "img/mes-outcome.4ccf62be.jpg";